<template>
  <div id="recoverPassword">
    <div class="van-hairline--bottom background_color_d6f1ec font_weight_bold" style="z-index: 1;" v-show="$vuetify.breakpoint.smAndDown">
      <v-row gutter="5" type="flex" align="center" justify="space-between">
        <v-col cols="2" />
        <v-col cols="8">
          <div class="background_color_d6f1ec van-nav-bar">
            <div class="van-ellipsis van-nav-bar__title" v-show="stage == 1">{{ $t("password.recoverPassword") }}</div>
            <div class="van-ellipsis van-nav-bar__title" v-show="stage == 2">{{ $t("password.verifyTempPassword") }}</div>
            <div class="van-ellipsis van-nav-bar__title" v-show="stage == 3">{{ $t("password.changePassword") }}</div>
          </div>
        </v-col>
        <v-col cols="2" class="margin_top_12" v-show="$enableShoppingCart"> </v-col>
      </v-row>
    </div>

    <div class="content2">
      <img src="../assets/img/icon_logo_2.png" class="logo_banner" />

      <div class="content" v-show="stage == 1">
        <v-text-field class="input" v-model="email" label="email address" prepend-icon="mdi-email"> </v-text-field>
        <v-btn class="btn" outlined rounded @click="toSendPswd"> {{ $t("password.sendTempPassword") }} </v-btn>
      </div>

      <div class="content" v-show="stage == 2">
        <v-text-field class="input" v-model="email" label="email address" readonly prepend-icon="mdi-email"> </v-text-field>
        <v-text-field
          class="input"
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          label="Temporary Password"
          prepend-icon="mdi-lock"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
        <v-btn class="btn" outlined rounded @click="toVerifyPswd"> {{ $t("password.verify") }} </v-btn>
        <v-btn class="btn" outlined rounded @click="toResendPswd"> {{ $t("password.resendTempPassword") }} </v-btn>
      </div>

      <div class="content" v-show="stage == 3">
        <v-text-field class="input" v-model="email" label="email address" readonly prepend-icon="mdi-email"> </v-text-field>
        <v-text-field
          class="input"
          v-model="password1"
          :type="showPassword1 ? 'text' : 'password'"
          label="New Password"
          prepend-icon="mdi-lock"
          :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword1 = !showPassword1"
        ></v-text-field>
        <v-text-field
          class="input"
          v-model="password2"
          :type="showPassword2 ? 'text' : 'password'"
          label="confirm New Password"
          prepend-icon="mdi-lock"
          :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword2 = !showPassword2"
        ></v-text-field>
        <v-alert type="error" border="right" colored-border dense elevation="2" v-show="password1 != '' && password2 != '' && password1 != password2">
          {{ $t("password.notMatch") }}
        </v-alert>
        <v-btn class="btn" outlined rounded @click="toChangePswd"> {{ $t("password.change") }} </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {
      email: "",
      password: "",
      password1: "",
      password2: "",
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      stage: 1, // 1 - ask email, 2 - ask password, 3 - change password
    };
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
  },
  mounted() {
    this.$parent.curTab = 4;
  },
  methods: {
    // ------------------------------------------------------------------------ toSendPswd
    toSendPswd() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        email: $this.email,
      };

      $this.$ajax2
        .post("SendTempPassword", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            if (rpdata.data.data.result && rpdata.data.data.result === true) {
              $this.$toast({
                message: $this.$t("password.sent"),
                position: "bottom",
              });
              $this.stage = 2;
            } else {
              $this.$toast({
                message: "Fail to send",
                position: "bottom",
              });
            }
          } else {
            $this.$toast({
              message: rpdata.data.meta.msg,
              position: "bottom",
            });
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ toResendPswd
    toResendPswd() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        email: $this.email,
      };

      $this.$ajax2
        .post("ResendTempPassword", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            if (rpdata.data.data.result && rpdata.data.data.result === true) {
              $this.$toast({
                message: $this.$t("password.sent"),
                position: "bottom",
              });
            } else {
              $this.$toast({
                message: "Fail to send",
                position: "bottom",
              });
            }
          } else {
            $this.$toast({
              message: rpdata.data.meta.msg,
              position: "bottom",
            });
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ toVerifyPswd
    toVerifyPswd() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        email: $this.email,
        tmpPassword: $this.password,
      };

      $this.$ajax2
        .post("ValidateMember", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.$store.commit("member", rpdata.data.data);
            $this.stage = 3;
            $this.$toast({
              message: $this.$t("login.Success"),
              position: "bottom",
            });
          } else {
            $this.$store.commit("member", {});
            $this.$toast({
              message: rpdata.data.meta.msg,
              position: "bottom",
            });
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ toChangePswd
    toChangePswd() {
      let $this = this;
      if (this.password1 == this.password2 && this.member.SessionToken) {
        let obj = {
          AppVersion: this.$version,
          SessionId: this.member.SessionId,
          SessionToken: this.member.SessionToken,
          tmpPassword: this.password,
          newPassword: this.password1,
        };
        $this.$ajax2
          .post("ChangeMemberPassword ", obj, $this.$ajaxHeader)
          .then(function(rpdata) {
            if (rpdata.data.meta.code == "200") {
              $this.$toast({
                message: "password updated",
                position: "bottom",
              });
              $this.$router.push({ name: "member" });
            }
          })
          .catch(function(err) {}); // eslint-disable-line
      }
    },
  },
};
</script>

<style>
#recoverPassword .btn {
  color: indigo;
  text-transform: none !important;
  margin: 3%;
  /* margin-top: 5%;
  margin-left: 5%;
  margin-right: 5%; */
  width: 90%;
}
#recoverPassword .input {
  width: 90%;
  border: 0;
  padding: 0 20px;
}
#recoverPassword .content {
  margin: 15% 10% 2% 10%;
}
#recoverPassword .login_bar {
  padding: 15px 10px;
  border-bottom: 1px solid #eeeeee;
}
#recoverPassword .logo {
  width: 20%;
  display: block;
  margin: 0 auto;
  padding-top: 40px;
}
#recoverPassword .logo_banner {
  width: 80%;
  display: block;
  margin: 0 auto;
  padding-top: 20px;
}
#recoverPassword {
  background-color: white;
  /* height: -webkit-fill-available; */
}
</style>
